/* eslint-disable react/prop-types */
import React from 'react'
import { ReactComponent as UploadCloud } from '@mike/mike-shared-frontend/media/icons/UploadCloud'
import Renders from './renders'
import { Typography, TableBody, TableRow, TableCell } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Theme } from '@mui/material/styles'

type MikeTheme = Theme & {
  palette: Theme['palette'] & {
    mediumGrey?: { main: string }
  }
}

const StyledDragLabel = styled(Typography)(({ theme }) => ({
  color: theme.palette.secondary.main
}))

const StyledFirstColumn = styled(TableCell)(({ theme }) => ({
  paddingLeft: theme.spacing(4)
}))

const StyledLastColumn = styled(TableCell)(({ theme }) => ({
  paddingRight: theme.spacing(4)
}))

const StyledMiddleColumn = styled(TableCell)({})

const StyledDragIconLabelContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center'
})

interface IProps {
  columns: Array<any>
  dragOver: boolean
  label?: string
  height?: string
}

const TableBodyDragAndDropArea = (props: IProps) => {
  const { columns, dragOver, label = 'Drop to upload', height } = props

  const [columsMid, setColumsMid] = React.useState(0)

  React.useEffect(() => {
    setColumsMid(Math.floor(columns.length / 2) - 1)
  }, [columns])

  return (
    <TableBody>
      <TableRow
        role="checkbox"
        tabIndex={-1}
        sx={theme => {
          const t = theme as MikeTheme
          const secondary = theme.palette.secondary.main
          const mediumGrey = t.palette.mediumGrey?.main ?? '#ccc'
          return {
            height: height,
            backgroundImage: dragOver
              ? ''
              : `repeating-linear-gradient(to right, ${secondary} 0%, ${secondary} 50%, transparent 50%, transparent 100%), repeating-linear-gradient(to right, ${secondary} 0%, ${secondary} 50%, transparent 50%, transparent 100%), repeating-linear-gradient(to bottom, ${secondary} 0%, ${secondary} 50%, transparent 50%, transparent 100%), repeating-linear-gradient(to bottom, ${secondary} 0%, ${secondary} 50%, transparent 50%, transparent 100%)`,
            backgroundPosition: dragOver
              ? ''
              : 'left top, left bottom, left top, right top',
            backgroundRepeat: dragOver
              ? ''
              : 'repeat-x, repeat-x, repeat-y, repeat-y',
            backgroundSize: dragOver
              ? ''
              : '20px 3px, 20px 3px, 3px 20px, 3px 20px',
            borderTop: dragOver ? `3px solid ${secondary}` : 'none',
            borderBottom: dragOver ? `3px solid ${secondary}` : 'none',
            borderLeft: dragOver ? `3px solid ${secondary}` : 'none',
            backgroundColor: !dragOver
              ? theme.palette.background.paper
              : mediumGrey,
            opacity: dragOver ? 0.8 : 1
          }
        }}
      >
        {columns.map((_head, index) => {
          const CellComponent =
            index === 0
              ? StyledFirstColumn
              : index === columns.length - 1
              ? StyledLastColumn
              : StyledMiddleColumn

          return (
            <CellComponent padding={'checkbox'} key={index}>
              {index === columsMid && (
                <StyledDragIconLabelContainer>
                  <UploadCloud className={Renders.iconActionStyle()} />
                  <StyledDragLabel variant="body2">{label}</StyledDragLabel>
                </StyledDragIconLabelContainer>
              )}
            </CellComponent>
          )
        })}
      </TableRow>
    </TableBody>
  )
}

export default TableBodyDragAndDropArea
